import * as React from 'react';
import { AppBarComponent } from '@syncfusion/ej2-react-navigations';
import { useState } from 'react';
import { MessageComponent } from '@syncfusion/ej2-react-notifications';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { IDocumentLoader } from './types/document';

interface IErrorLoadingProps {
    documentLoader: IDocumentLoader;
    message: string;
    reload: any;
}

function ErrorLoadingDocument(props: IErrorLoadingProps) {

    const [visible, setVisible] = useState<boolean>(true);
    const [showDetails, setShowDetails] = useState<boolean>(true);
    const [cssClass, setCssClass] = useState<string>(
        'e-outline e-primary e-success msg-hidden'
    );
    
    const closed = () => {
        setCssClass('e-outline e-primary e-success');
    };

    const showErrorDetails = () => {
        setShowDetails(!showDetails);
    }

    const contentTemplate = () => {
        return (
            <div>
                <h1>На жаль, сталася помилка</h1>
                <p>{props.message ? props.message : 'Ми вже працюємо та невдовзі все буде гаразд'}</p>
                { !props.documentLoader.document || props.documentLoader.document.access.allowRead ? 
                    <div style={{ textAlign: 'left', marginTop: '20px' }}>
                        <ButtonComponent id="commitBtn" cssClass="e-link" content={"Спробувати ще раз"}/>
                    </div>
                    : <></>
                }
                <div style={{ textAlign: 'left', marginTop: '20px' }}>
                    <ButtonComponent id="detailsBtn" cssClass="e-link" 
                        content={
                            showDetails ? 
                                "Сховати інформацію про помилку" : "Інформація про помилку"
                        } 
                        onClick={showErrorDetails}
                    />
                </div>
                {showDetails &&
                    <div style={{ marginTop: '20px' }}>
                        <div className="e-card" id="basic">
                            <div className="e-card-header">
                                <div className="e-card-header-caption">
                                    <div className="e-card-title">Повідомлення про помилку:</div>
                                    <div className="e-card-title"><strong>{props.documentLoader.error.message}</strong></div>
                                </div>
                            </div>
                            <div className="e-card-content">
                                <p>Детальна інформація:</p>
                                <strong>{props.documentLoader.error.details}</strong>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    };

    return (
        <React.Fragment>
            <div className="row" style={{ maxHeight: '40px', marginBottom: '20px' }}>
                <div className="col-md-12">
                    <AppBarComponent mode="Dense" colorMode="Primary">
                        <ButtonComponent 
                            ref={(denseBtn: any) => (denseBtn = denseBtn)} 
                            aria-label='menu' 
                            cssClass='e-inherit menu' 
                            iconCss='e-icons e-menu'
                        ></ButtonComponent>
                        <span className="dense">{localStorage.getItem('appName')}</span>
                        <div className="e-appbar-spacer"></div>
                    </AppBarComponent>
                </div>
            </div>
                <div className="msg-template-section">
                    <div className="content-section">
                        <MessageComponent id="msg_template" visible={visible} content={contentTemplate} severity="Error" closed={closed} />
                    </div>
                </div>
        </React.Fragment>
    );
}
export default ErrorLoadingDocument;